import {
	TEMPLATE,
	TemplateStateHandler,
	universalAdPackage,
	type AdSlot,
	communicationService,
} from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';
import { AD_ENGINE_STICKY_TLB_LEFT } from '../../../../../communication/events/events-ad-engine-uap';

@Injectable({ autobind: false })
export class StickyTlbConfigHandler implements TemplateStateHandler {
	constructor(@Inject(TEMPLATE.SLOT) private adSlot: AdSlot) {}

	async onEnter(): Promise<void> {
		document.querySelector('.top-ads-container')?.classList.add('sticky-tlb-placeholder');

		this.adSlot.setConfigProperty('showManually', true);
		this.adSlot.addClass('expanded-slot');
		this.adSlot.addClass('sticky-tlb');

		this.adSlot.setConfigProperty('useGptOnloadEvent', true);
		this.adSlot.loaded.then(() => {
			this.adSlot.emitEvent(universalAdPackage.SLOT_STICKY_READY_STATE);
		});
	}

	async onLeave(): Promise<void> {
		this.adSlot.show();
		document.body.classList.add('has-uap');
		document.body.classList.add('has-sticky-tlb');

		communicationService.emit(AD_ENGINE_STICKY_TLB_LEFT);
	}

	async onDestroy(): Promise<void> {
		document.body.classList.remove('has-uap');
		document.body.classList.remove('has-sticky-tlb');
	}
}
